<template>
  <div v-show="show" id="vp" class="v-player-mask">
    <div class="v-player-wrap corner">
      <i class="close" @click="close"/>
      <v-player ref="player" class="v-player" :options="options"/>
      <div class="corner2"/>
    </div>
    <guide-button class="btn-rt" @click="close">继续</guide-button>
  </div>
</template>

<script>
import VueDPlayer from 'vue-dplayer'
import 'vue-dplayer/dist/vue-dplayer.css'

export default {
  name: 'VideoPlayer',
  components: {
    vPlayer: VueDPlayer,
  },
  data () {
    return {
      show: false,
      playing: false,
      options: {
        autoplay: true,
        theme: '#fadfa3',
        loop: false,
        screenshot: false,
        hotkey: false,
        preload: 'auto',
        mutex: true,
      },
    }
  },
  mounted () {
    this.reset()
    this.$refs.player.dp.on('canplay', () => {
      if (this.show) {
        this.$refs.player.dp.play()
      }
    })
    this.$refs.player.dp.on('playing', () => {
      if (this.show) {
        this.playing = true
      }
    })
    this.$refs.player.dp.on('pause', () => {
      this.playing = false
    })
  },
  methods: {
    reset () {
      const setting = this.$refs.player.$el.querySelector('.dplayer-controller .dplayer-setting')
      setting.style.display = 'none'
    },
    play (video) {
      this.show = true
      this.$refs.player.dp.switchVideo(video)
      this.$refs.player.dp.video.load()
    },
    clear () {
      this.$refs.player.dp.pause()
      this.show = false
    },
    close () {
      this.clear()
      this.callback()
    },
    callback () {

    },
  },
}
</script>

<style lang="scss" >
#vp {
  &.v-player-mask {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  }
  .v-player-wrap {
    position: relative;
    width: 14.4rem;
    height: 8.1rem;
    padding: 0.15rem;
    background-color: #3a6aa2;
    box-shadow: 0.05rem 0.05rem 0.1rem #0c103a;
    .v-player {
      font-size: 0.12rem;
      z-index: 11;
    }
    .dplayer-fulled {
      width: 100%;
      height: 100%;
    }
  }
  .close {
    position: absolute;
    top: -0.5rem;
    right: -0.5rem;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    background-image: url(../assets/img/icon/close.png);
    background-size: contain;
    cursor: pointer;
    z-index: 12;
  }
}
</style>
